import { Injectable } from '@angular/core';
import { CertRequirementCatalogOverrideCatalog, CertRequirementCatalogOverrideGroup, CertRequirementCatalogOverrideGroupDetail, RequestById, RequestByIdOrExternalId } from '@ats/api/cm';
import { gql, Query } from 'apollo-angular';

export type OverrideNameList = Pick<CertRequirementCatalogOverrideCatalog, 'id' | 'name'>;

type OverrideNameListResponse = {
	certRequirementCatalogDetail: {
        id: number;
		overrideGroupDetail: {
			id: number;
			name: string;
			catalogList: OverrideNameList[];
		};
	};
};

@Injectable()
export class OverrideNameGqlService extends Query<
OverrideNameListResponse,
	{ catalogRequest: RequestByIdOrExternalId, groupRequest: RequestById }
> {
	readonly document = gql`
		query getOverrideNames($catalogRequest: RequestByIdOrExternalId!, $groupRequest: RequestById!) {
			certRequirementCatalogDetail(request: $catalogRequest) {
				overrideGroupDetail(request: $groupRequest) {
					id
					name
					catalogList {
						id
						name
					}
				}
			}
		}
	`;
}
